import * as React from 'react';
import * as styles from './styles.scss';
import { AssetIcon, AssetTextField } from 'owa-timestream-asset-sdk';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import type { LinkPayload } from '../schema';
import { observer } from 'mobx-react-lite';
import LinkPreviewView from './LinkPreviewView';
import useLinkViewState from '../util/useLinkViewState';

/** Renders a Link asset */
export default observer(function LinkView(props: AssetCommonViewProps<LinkPayload>) {
    const { iconName, iconTitle, linkPreview, titleProps, urlEditorProps } = useLinkViewState(
        props.payload
    );

    return (
        <LinkPreviewView linkPreview={linkPreview} titleProps={titleProps}>
            {props.DueDate}
            <div className={styles.editor}>
                <AssetIcon className={styles.icon} iconName={iconName} title={iconTitle || ''} />
                <AssetTextField
                    className={styles.url}
                    secondary={true}
                    dir="ltr" // urls should be displayed in ltr only
                    {...urlEditorProps}
                />
            </div>
        </LinkPreviewView>
    );
});
